import StoreUpdateEvents from "../constants/events/StoreUpdateEvents";
import UIInteractionEvents from "../constants/events/UIInteractionEvents";
import LoadingStates from "../constants/states/LoadingStates";
import ActionResultEvents from "../constants/events/ActionResultEvents";
import SecureBaseStore from "./SecureBaseStore";

class AdvertisementOwnerProfileState {
    constructor(
        loadingState,
        memberId,
        displayName,
        email,
        phoneNumber,
        about
    ) {
        this.loadingState = loadingState;
        this.memberId = memberId;
        this.displayName = displayName;
        this.email = email;
        this.phoneNumber = phoneNumber;
        this.about = about;
    }

    equals(other) {
        return this.loadingState === other.loadingState &&
            this.memberId === other.memberId &&
            this.displayName === other.displayName &&
            this.email === other.email &&
            this.phoneNumber === other.phoneNumber &&
            this.about === other.about;
    }
}

class ImmutableAdvertisementOwnerProfileStateBuilder {

    constructor() {
        this.loadingState = LoadingStates.INITIALIZED;
        this.memberId = 0;
        this.displayName = "";
        this.email = "";
        this.phoneNumber = "";
        this.about = "";
    }

    static fromState(state) {
        return new ImmutableAdvertisementOwnerProfileStateBuilder()
            .setLoadingState(state.loadingState)
            .setProfile(
                state.memberId,
                state.displayName,
                state.email,
                state.phoneNumber,
                state.about);
    }

    setLoadingState(loadingState) {
        this.loadingState = loadingState;
        return this;
    }

    setProfile(
        memberId,
        displayName,
        email,
        phoneNumber,
        about
    ) {
        this.memberId = memberId;
        this.displayName = displayName;
        this.email = email;
        this.phoneNumber = phoneNumber;
        this.about = about;
        return this;
    }

    build() {
        return Object.freeze(
            new AdvertisementOwnerProfileState(
                this.loadingState,
                this.memberId,
                this.displayName,
                this.email,
                this.phoneNumber,
                this.about
            ));
    }
}


class AdvertisementOwnerProfileStore extends SecureBaseStore {

    constructor() {
        super(StoreUpdateEvents.ADVERTISEMENT_OWNER_PROFILE_STORE_UPDATE, ImmutableAdvertisementOwnerProfileStateBuilder);
        this.subscribeToEvent(ActionResultEvents.ADVERTISEMENT_OWNER_SHAREABLE_PROFILE_LOADED, this.handleProfileLoaded);
        this.subscribeToEvent(UIInteractionEvents.ADVERTISEMENT_OWNER_PROFILE_UNMOUNT, this.resetStore);
        this.subscribeToEvent(UIInteractionEvents.SHAREABLE_PROFILE_UNAUTHORIZED, this.handleUnauthorized);
    }

    handleProfileLoaded = (topic, data) => {
        return ImmutableAdvertisementOwnerProfileStateBuilder.fromState(this.state)
            .setLoadingState(LoadingStates.FINISHED_LOADING)
            .setProfile(
                data.memberId,
                data.displayName,
                data.email,
                data.phoneNumber,
                data.about)
            .build();
    };

    handleUnauthorized = (topic, data) => {
        return ImmutableAdvertisementOwnerProfileStateBuilder.fromState(this.state)
            .setLoadingState(LoadingStates.FAILED_TO_LOAD)
            .build();
    }

}

export default new AdvertisementOwnerProfileStore();